import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface Notification {
    message: string
    severity: 'error' | 'warning' | 'info' | 'success'
}

export interface NotificationState {
    current: Notification | null
}

const initialState: NotificationState = { current: null }

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        showNotification(state, action: PayloadAction<Notification>) {
            state.current = action.payload
        },
        clearNotification(state) {
            state.current = null
        },
    },
})

export const { showNotification, clearNotification } = notificationSlice.actions
export const notificationReducer = notificationSlice.reducer
